import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import {SettingsComponent} from './settings.component';
import { SamlSignOnComponent } from './components/saml-signon/saml-signon.component'
import { MaterialModule } from 'src/app/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SettingsRoutingModule } from './settings-routing.module';
import { CeleryTaskViewComponent } from './components/celery-task-view/celery-task-view.component';



@NgModule({
  declarations: [
  SettingsComponent,
  SamlSignOnComponent,
  CeleryTaskViewComponent
  ],
  imports: [
    CommonModule,
    SettingsRoutingModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    DatePipe
  ],
  exports: [
    SettingsComponent
  ]
})
export class SettingsModule { }
